import { render } from "./ApplicationSummary.vue?vue&type=template&id=5a4c2b99&scoped=true"
import script from "./ApplicationSummary.vue?vue&type=script&lang=js"
export * from "./ApplicationSummary.vue?vue&type=script&lang=js"

import "./ApplicationSummary.vue?vue&type=style&index=0&id=5a4c2b99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4c2b99"]])

export default __exports__